import { PREFIX } from '@/config';
import cx from 'classnames';
export const useStyleOverrides = (props, name) => {
    const className = `${PREFIX}-${name}`;
    return {
        style: props.style,
        className: cx(className, props.className),
    };
};
